export default __webpack_public_path__ + "static/media/adir_shiffman.1aac3aa1.jpg";